import { SvgIcon, SxProps, Theme, useTheme } from "@mui/material";
import { ReactElement } from "react";

export default function EmptyDataSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    const theme = useTheme();
    const color = theme.palette.primary.main;
    return (
        <SvgIcon
            viewBox="0 0 116 116"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ width: 116, height: 116, fill: "none", ...sx }}
        >
            <path
                d="M57.6522 115.304C89.4926 115.304 115.304 89.4926 115.304 57.6522C115.304 25.8118 89.4926 0 57.6522 0C25.8118 0 0 25.8118 0 57.6522C0 89.4926 25.8118 115.304 57.6522 115.304Z"
                fill="url(#paint0_linear_8860_46436)"
                fillOpacity="0.5"
            />
            <g filter="url(#filter0_d_8860_46436)">
                <path
                    d="M47.9656 75.0166C50.1399 75.0166 51.9086 76.3832 51.9086 78.0633C51.9086 80.5218 54.4969 82.5217 57.6787 82.5217C60.8606 82.5217 63.4489 80.5263 63.4489 78.0737C63.4489 76.3832 65.2176 75.0166 67.3919 75.0166H87.9085C87.9994 75.0166 88.0846 75.0326 88.174 75.0373L78.6688 48.7848C78.5111 48.3481 77.9984 48.0435 77.407 48.0435H37.5037C36.8991 48.0435 36.3865 48.3583 36.2287 48.8051L27.1305 75.0415C27.2373 75.0347 27.3399 75.0166 27.449 75.0166H47.9656Z"
                    fill="white"
                />
            </g>
            <g filter="url(#filter1_d_8860_46436)">
                <path
                    d="M87.9411 77.6671H67.3842C66.6599 77.6671 66.0673 78.2597 66.0673 78.984C66.0673 78.984 66.0673 78.984 66.0673 78.9972C66.0673 83.6327 62.2877 87.399 57.6522 87.399C53.0167 87.399 49.2371 83.6195 49.2371 78.984C49.2371 78.2597 48.6446 77.6671 47.9202 77.6671H27.3633C26.639 77.6671 26.0464 78.2597 26.0464 78.984V98.7245C26.0464 99.4488 26.639 100.041 27.3633 100.041H87.9411C88.6654 100.041 89.258 99.4488 89.258 98.7245V78.984C89.258 78.2597 88.6654 77.6671 87.9411 77.6671Z"
                    fill="white"
                />
            </g>
            <path
                opacity="0.8"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.8709 78.5219C51.8709 76.5948 50.0987 75.0271 47.9201 75.0271H33.9076L40.5593 53.6957H56.8032L56.8044 53.6952L56.8056 53.6957H74.1002L76.582 60.9913L76.6802 61.0276L81.502 75.0271H67.3844C65.2058 75.0271 63.4337 76.5948 63.4337 78.5338C63.4337 81.3472 60.8404 83.636 57.6523 83.636C54.4642 83.636 51.8709 81.342 51.8709 78.5219Z"
                fill="url(#paint1_linear_8860_46436)"
            />
            <path
                d="M57.6522 37.3043V44.0869"
                stroke="url(#paint2_linear_8860_46436)"
                strokeWidth="1.13043"
                strokeLinecap="round"
            />
            <path
                d="M75.4565 36.7857L71.2174 44.4567"
                stroke="url(#paint3_linear_8860_46436)"
                strokeWidth="1.13043"
                strokeLinecap="round"
            />
            <path
                d="M39.5653 36.7391L44.0778 44.2775"
                stroke="url(#paint4_linear_8860_46436)"
                strokeWidth="1.13043"
                strokeLinecap="round"
            />
            <defs>
                <filter
                    id="filter0_d_8860_46436"
                    x="15.8261"
                    y="39"
                    width="83.6522"
                    height="57.087"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.26087" />
                    <feGaussianBlur stdDeviation="5.65217" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.101961 0 0 0 0 0.384314 0 0 0 0 0.94902 0 0 0 0.15 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_8860_46436"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_8860_46436"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_8860_46436"
                    x="14.742"
                    y="68.6236"
                    width="85.8204"
                    height="44.983"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.26087" />
                    <feGaussianBlur stdDeviation="5.65217" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.101961 0 0 0 0 0.384314 0 0 0 0 0.94902 0 0 0 0.15 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_8860_46436"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_8860_46436"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_8860_46436"
                    x1="57.6522"
                    y1="-1.69275e-08"
                    x2="57.3682"
                    y2="83.7802"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} stopOpacity="0.5" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_8860_46436"
                    x1="57.7048"
                    y1="53.6952"
                    x2="57.7048"
                    y2="83.636"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_8860_46436"
                    x1="58.1522"
                    y1="37.3043"
                    x2="58.1522"
                    y2="44.0869"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_8860_46436"
                    x1="73.4739"
                    y1="36.7624"
                    x2="73.3833"
                    y2="44.4821"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_8860_46436"
                    x1="41.9543"
                    y1="36.7672"
                    x2="41.8665"
                    y2="44.2516"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
            </defs>
        </SvgIcon>
    );
}
